export class MapboxConstants {
  /*
    We've moved the token here to prevent babel from rewriting it at build time.
    Originally we had it hardcoded in each map component
  */
  public static readonly ACCESS_TOKEN =
    process.env.REACT_APP_MAPBOX_TOKEN ||
    "pk.eyJ1Ijoiamlhbm5hbmx1IiwiYSI6ImNtM3BvdjNpdjBlN3oycXM0eXdmcWRxODkifQ._puZrLst8YIgoDn2sye1tQ";
}
